
const toNumber = (value: string | number): number => {
    if (typeof value === 'number') {
        return value;
    }

    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
};

export default toNumber;
